module.exports = __webpack_public_path__ + "static/media/xuc.f667f3fb.svg";